import React from 'react';
import PropTypes from 'prop-types';

const CivilCasesResultTable = ({ data }) => (
  <table className="ir-search-table-results sticky-enabled sticky-table">
    <thead className="tableHeader-processed">
      <tr>
        <th>Case Title</th>
        <th>Court</th>
        <th>Case No</th>
        <th>NOS</th>
        <th>Date Filed</th>
        <th>Date Closed</th>
      </tr>
    </thead>
    <tbody>
      {data.map((row, idx) => (
        <tr key={idx}>
          <td>{row.case_title}</td>
          <td>{row.court_code}</td>
          <td className="ir-search-no-wrap">
            <a
              href={`/rpc/legacy/case-menu-redirect/${row.court_code}/${row.case_no}`}
              target="_blank"
            >
              {row.case_no}
            </a>
          </td>
          <td>{row.nature_of_suit_code}</td>
          <td>{row.date_filed}</td>
          <td>{row.date_closed}</td>
        </tr>
      ))}
    </tbody>
  </table>
);

CivilCasesResultTable.propTypes = {
  data: PropTypes.array.isRequired,
};

export default CivilCasesResultTable;



// WEBPACK FOOTER //
// ./src/components/search/localCourtSearch/CivilCasesResultTable.jsx